var _rect, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgUser = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "user",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 26,
    height: 26,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "np_user_415727_000000",
    transform: "translate(7.312 6.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5603",
    "data-name": "Path 5603",
    d: "M27.3,58.63A4.548,4.548,0,0,0,22.843,54.9H20.571a4.561,4.561,0,0,0-4.5,3.832,1.814,1.814,0,0,0,1.792,2.106H25.53A1.824,1.824,0,0,0,27.322,58.7Z",
    transform: "translate(-16.051 -47.836)",
    fill: "#5636d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5604",
    "data-name": "Path 5604",
    d: "M31.578,17.609a3.374,3.374,0,0,0,4.71.066l.033-.033a3,3,0,0,0,.249-4.1,3.379,3.379,0,0,0-5.258.066,3.014,3.014,0,0,0,.249,3.981Z",
    transform: "translate(-28.252 -12.322)",
    fill: "#5636d0"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUser, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/user.283388a1.svg";
export { ForwardRef as ReactComponent };